// src/App.js  (hive.eilanapplication)

import React, { Suspense, useEffect } from 'react';
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom';
import { CSpinner } from '@coreui/react';
import './scss/style.scss';
import ErrorBoundary from './views/admin/LeaveManagement/ErrorBoundary';
import {
  initChatUnreadListener,
} from './components/chatUnreadListener';

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));

// Pages
const Login          = React.lazy(() => import('./views/pages/login/Login'));
const Register       = React.lazy(() => import('./views/pages/register/Register'));
const Page404        = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500        = React.lazy(() => import('./views/pages/page500/Page500'));
const ForgotPassword = React.lazy(() => import('./views/pages/login/ForgotPassword'));
const OTPPage        = React.lazy(() => import('./views/pages/login/OTPPage'));
const SetNewPassword = React.lazy(() => import('./views/pages/login/SetNewPassword'));

// Protected Route
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
};

const App = () => {

  useEffect(() => {
    // Resolve userId — Hive app stores in sessionData, fallback to token
    let userId = null;
    try {
      const raw = localStorage.getItem('sessionData');
      if (raw) {
        const obj = JSON.parse(raw);
        userId = obj?.userId || obj?.employeeId || obj?.id || null;
        if (userId) userId = String(userId);
      }
    } catch { /* ignore */ }

    if (!userId) {
      try {
        const raw = localStorage.getItem('token');
        if (raw) {
          const obj = JSON.parse(raw);
          userId = obj?.userId || obj?.employeeId || obj?.id || null;
          if (userId) userId = String(userId);
        }
      } catch { /* plain JWT */ }
    }

    if (userId) {
      initChatUnreadListener(userId);
    }
  }, []);

  return (
    <ErrorBoundary>
      <HashRouter>
        <Suspense
          fallback={
            <div className="pt-3 text-center">
              <CSpinner color="primary" variant="grow" />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />

            {/* Public */}
            <Route path="/login"          element={<Login />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/otpPage"        element={<OTPPage />} />
            <Route path="/setNewPassword" element={<SetNewPassword />} />
            <Route path="/register"       element={<Register />} />
            <Route path="/404"            element={<Page404 />} />
            <Route path="/500"            element={<Page500 />} />

            {/* Protected — DefaultLayout handles all internal routing */}
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <DefaultLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </HashRouter>
    </ErrorBoundary>
  );
};

export default App;